import axios, { AxiosResponse } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiUrl from "../constants/apiUrl";
import type { InterestForm, CreateInterestForm } from "../@types";
import api from "../config/apiClient";

const baseApiUrl = `${apiUrl}/interest-form/`;
const baseApiUrlDeleteEdit = `${apiUrl}/interest-form/detail/`;

// Values (OK to keep SCREAMING_SNAKE_CASE)
export const GET_INTEREST_FORMS = "GET_INTEREST_FORMS";
export const CREATE_INTEREST_FORM = "CREATE_INTEREST_FORM";
export const DELETE_INTEREST_FORM = "DELETE_INTEREST_FORM";
export const EDIT_INTEREST_FORM = "EDIT_INTEREST_FORM";
export const GET_INTEREST_FORM = "GET_INTEREST_FORM";

// Admin list
export const getInterestForms = createAsyncThunk(
  GET_INTEREST_FORMS,
  async (_, { rejectWithValue }) => {
    try {
      const res: AxiosResponse<InterestForm[]> = await api.get(baseApiUrl);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? err);
    }
  }
);

// Public create
export const createInterestForm = createAsyncThunk(
  CREATE_INTEREST_FORM,
  async (formData: CreateInterestForm, { rejectWithValue }) => {
    try {
      const res: AxiosResponse<InterestForm> = await api.post(baseApiUrl, formData);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? err);
    }
  }
);

// Admin delete
export const deleteInterestForm = createAsyncThunk(
  DELETE_INTEREST_FORM,
  async (id: number | string, { rejectWithValue }) => {
    try {
      await api.delete(`${baseApiUrlDeleteEdit}${id}/`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? err);
    }
  }
);

// Admin edit
export const editInterestForm = createAsyncThunk(
  EDIT_INTEREST_FORM,
  async (updated: InterestForm, { rejectWithValue }) => {
    try {
      const { id, ...payload } = updated;
      const res: AxiosResponse<InterestForm> = await api.put(`${baseApiUrlDeleteEdit}${id}/`, payload);
      return res.data ?? updated;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? err);
    }
  }
);

// Admin get single
export const getInterestForm = createAsyncThunk(
  GET_INTEREST_FORM,
  async (id: number | string, { rejectWithValue }) => {
    try {
      const res: AxiosResponse<InterestForm> = await api.get(`${baseApiUrl}${id}/`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err?.response?.data ?? err);
    }
  }
);

// Clear
export const clearInterestForms = createAsyncThunk("CLEAR_INTEREST_FORMS", async () => null);
